import type { SVGProps } from 'react'
const SvgSyMessage = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M5.871 7.816a.75.75 0 0 0-.502.278.75.75 0 0 0 .117 1.052l4.303 3.436.004.004a2.98 2.98 0 0 0 3.672 0l.008-.006 4.265-3.435a.75.75 0 0 0 .114-1.055.75.75 0 0 0-1.055-.113l-4.258 3.427a1.464 1.464 0 0 1-1.818 0h-.002l-4.297-3.43a.75.75 0 0 0-.55-.158"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M6.889 2.25c-3.327 0-5.639 2.79-5.639 6.045v6.527c0 3.256 2.312 6.043 5.639 6.043h9.435a5.7 5.7 0 0 0 4.121-1.83 5.77 5.77 0 0 0 1.526-4.258l.002.045V8.295l-.002.043a5.77 5.77 0 0 0-1.526-4.258 5.7 5.7 0 0 0-4.12-1.83h-.009zm0 1.5h9.418a4.2 4.2 0 0 1 3.039 1.35 4.27 4.27 0 0 1 1.127 3.15v6.615a4.27 4.27 0 0 1-1.127 3.15 4.2 4.2 0 0 1-3.04 1.35H6.89c-2.513 0-4.139-1.961-4.139-4.543V8.295c0-2.582 1.626-4.545 4.139-4.545"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyMessage
